import moment from 'moment';

// Start inclusive, end exclusive (ms since epoch).
export interface TimeRange {
  start: number;
  end: number;
}

const DEFAULT_RANGE_MONTHS = 12;

export function monthStart(t: number): number {
  return moment.utc(t).startOf('month').valueOf();
}

export function addMonths(t: number, months: number): number {
  return moment.utc(t).add(months, 'months').valueOf();
}

// The last 12 whole months of imagery (UTC), or all of it when there is less.
export function getDefaultRange(dates: Date[]): TimeRange | null {
  if (!dates.length) {
    return null;
  }
  const times = dates.map((d) => +d);
  const end = addMonths(monthStart(Math.max(...times)), 1);
  return {
    start: Math.max(addMonths(end, -DEFAULT_RANGE_MONTHS), monthStart(Math.min(...times))),
    end,
  };
}
